<div class="border-surface-200 dark:border-surface-700 p-0">
  <p-breadcrumb
    [model]="items"
    [home]="home"
    styleClass="p-0 m-0 bg-transparent"
    class=" [&_.p-breadcrumb-list_li:not(:last-child)_a]:opacity-60 [&_.p-breadcrumb-list_li:not(:last-child)_a]:text-base [&_.p-breadcrumb-list_li:not(:last-child)_a]:transition-opacity [&_.p-breadcrumb-list_li:not(:last-child)_a]:hover:opacity-80 [&_.p-breadcrumb-list_li:last-child_a]:opacity-100 [&_.p-breadcrumb-list_li:last-child_a]: [&_.p-breadcrumb-list_li:last-child_a]:text-surface-900 [&_.p-breadcrumb-list_li:last-child_a]:dark:text-surface-100 [&_.p-breadcrumb-list_li:last-child_a]:"
  />
</div>
